<div class="modal-header">
    <a class="icon-reject">
        <i class="fas fa-times-circle" (click)="cancel()"></i>
    </a>
</div>
<div class="modal-body userRegistrationApproval">
    <div class="both">
        <div id="selfRegistrationRoot">
            <div class="both"></div>
        </div>
    </div>
</div>